module.exports = __webpack_public_path__ + "static/img/bg@2x.f5d03bfe.png";